module.exports = __webpack_public_path__ + "img/icon-plus-primary-disabled.a804f71b.svg";